module.exports = "varying vec2 vUv;\r\nvarying vec3 vNormal;\r\n\r\nuniform float time;\r\n\r\nuniform sampler2D sphereLit;\r\n\r\n// Reference: http://www.iquilezles.org/www/articles/palettes/palettes.htm\r\nvec3 palette( float t, vec3 a, vec3 b, vec3 c, vec3 d)\r\n{\r\n    return saturate(a + b * cos(6.28318 * ( c * t + d)));\r\n}\r\n\r\nvoid main() \r\n{\r\n  \tgl_FragColor = vec4(.2 * abs(dot(vNormal, vec3(1,1,1))));\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/fakeBox.frag.glsl
// module id = 44
// module chunks = 0